import { object, number, boolean, ZodIssueCode, string } from 'zod';

import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';
import { LimitSchema } from '@occc/feat-limits';
import { withIsEnabled } from '@occc/validation';

export const requiresActivationSchema = object({
  id: string().optional(),
  mustFulfillWithinDays: number().optional(),
  isMustFulfillWithinEnabled: boolean(),
  allowMultipleFulfillmentsOnActivation: boolean(),
}).superRefine((data, ctx) => {
  if (data.isMustFulfillWithinEnabled && data.mustFulfillWithinDays === undefined) {
    ctx.addIssue({
      code: ZodIssueCode.custom,
      path: ['mustFulfillWithinDays'],
      message: IS_REQUIRED,
    });
  }
});

const defaultRequiresActivationValue = {
  isMustFulfillWithinEnabled: false,
  allowMultipleFulfillmentsOnActivation: false,
};

const RequiresActivationConstraintEnabledSchema = object({
  requiresActivation: requiresActivationSchema,
});

const RequiresActivationConstraintDisabledSchema = object({
  requiresActivation: requiresActivationSchema.optional().default(defaultRequiresActivationValue),
});

export const requiresActivationConstraintSchema = withIsEnabled(
  RequiresActivationConstraintEnabledSchema,
  RequiresActivationConstraintDisabledSchema,
);

export const requiresActivationZodConstraintSchema = requiresActivationConstraintSchema;

const RequiresActivationConstraintWithLimitsEnabledSchema = object({
  membership: LimitSchema,
  global: LimitSchema,
  requiresActivation: requiresActivationSchema,
});

const RequiresActivationConstraintWithLimitsDisabledSchema = object({
  membership: LimitSchema,
  global: LimitSchema,
  requiresActivation: requiresActivationSchema.optional().default(defaultRequiresActivationValue),
});

export const requiresActivationConstraintWithLimitsSchema = withIsEnabled(
  RequiresActivationConstraintWithLimitsEnabledSchema,
  RequiresActivationConstraintWithLimitsDisabledSchema,
);
